export class SessionStorageService {
  public static setItem = (key: string, value: string) => {
    sessionStorage.setItem(key, value);
  }

  public static getItem = (key: string): string | null => {
    return sessionStorage.getItem(key);
  }

  public static removeItem = (key: string) => {
    sessionStorage.removeItem(key);
  }

  public static clear = () => {
    sessionStorage.clear();
  }
}